import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { HeaderService } from './header.service';
import { ModaleComponent } from 'app/generic/modale/modale.component';
import { Router } from '@angular/router';
import { ConfirmModaleComponent } from 'app/generic/confirm-modal/confirm-modale.component';
import { environment } from 'environments/environment';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
  providers: [HeaderService]
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userfotoUrlOnly: boolean = false;
  user: any = null;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [];
  appInUso;
  anagraficaUser: any;
  imgUtente: any;
  notificheList: any = [];
  countNotifiche: number;
  viewNotifiche: boolean;
  listaNotificheToRemove: any[] = [];


  constructor(public modalComponent: ModaleComponent,
              private confirmModalComponent: ConfirmModaleComponent,
              private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private router: Router,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private authService: NbAuthService,
              private domSanitizer: DomSanitizer,
              private restService : HeaderService) {

                this.authService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {

        /* if (token.isValid()) {
          this.user = token.getPayload(); // here we receive a payload from the token and assigns it to our `user` variable 
        }
        console.log(token);
        console.log(this.user); */

      });
      setTimeout(() => {
        if(JSON.parse(sessionStorage.getItem("anagraficaUser"))!=null){
          // console.log("ANAG >>>", JSON.parse(sessionStorage.getItem("anagraficaUser")));
          this.anagraficaUser = JSON.parse(sessionStorage.getItem("anagraficaUser"));
          
          this.imgUtente = `data:image/jpeg;base64,${this.anagraficaUser.immagineProfilo}`;
          this.loadHeader();
  
        }

      }, 200);

  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    /* this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick); */

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userfotoUrlOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

      this.getAllNotifiche();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  loadHeader() {

    if(sessionStorage.getItem("authUser") != null) {
        
      this.user = JSON.parse(sessionStorage.getItem("authUser"));
      if(this.user!=null){
        if(this.anagraficaUser.immagineProfilo){
          this.user.fotoBase64=`data:image/jpeg;base64,${this.anagraficaUser.immagineProfilo}`
        } else {
          this.user.fotoBase64 = '../../../../assets/images/docente.png'
        }
        
      }
      if(this.user!=null && (this.user.tipoRuolo==2 || this.user.tipoRuolo==4 || this.user.tipoRuolo==5 || this.user.tipoRuolo==6) && this.user.actionRole==1) {
        this.user.tipoRuoloDesc += " (docente)" 
      }

    } else {
      setTimeout(() => {
        this.user = JSON.parse(sessionStorage.getItem("authUser"));
        if(!this.user){
          window.location.href = "/pages";
        }
      }, 500);
    }

    if(JSON.parse(sessionStorage.getItem("appInUso"))!=null) {
      this.appInUso = JSON.parse(sessionStorage.getItem("appInUso"));
      
    } else {

      this.getNameApp();
      
    }

    if(this.user!=null && ((this.user.tipoRuolo==2 || this.user.tipoRuolo==4 || this.user.tipoRuolo==5 || this.user.tipoRuolo==6) && this.appInUso.titolo == "INCARICHI")
        || ((this.user.tipoRuolo==4 || this.user.tipoRuolo==5 || this.user.tipoRuolo==6) && this.appInUso.titolo == "AUTOCERTIFICAZIONI")){ // && this.appInUso.titolo == "INCARICHI"

      var title = "Modalità";

      if(this.user.actionRole==2 || this.user.actionRole==4 || this.user.actionRole==5 || this.user.actionRole==6) {

        title += " docente";

      } else {

        if(this.user.tipoRuolo==2) {
          title += " direttore";
        }

        if(this.user.tipoRuolo==4) {
          title += " rettore";
        }

        if(this.user.tipoRuolo==5) {
          title += " vice direttore";
        }

        if(this.user.tipoRuolo==6) {
          title += " prorettore vicario";
        }

      }

      var app = "";
       
      if(this.appInUso.titolo == "INCARICHI") {
        app = "auth-com";
      } else if(this.appInUso.titolo == "AUTOCERTIFICAZIONI") {
        app = "gest-autocert";
      } else if(this.appInUso.titolo == "ANAGRAFICHE") {
        app = "gest-utenti";
      }

      this.userMenu.push({ title: title, icon: 'flip-2-outline', link: '/auth/switch-role/y/'+app });

    }

    if(this.isCollaudo() || this.isPreprod()){
      this.userMenu.push( 
        { title: 'Profilo', icon: 'person-outline', link: '/pages/gestione-profilo' },
        { title: 'Apps', icon: 'keypad-outline', link: '/pages/main-apps' },
        { title: 'Logout', icon: 'log-out-outline', link: '/auth/logout' }
      );
    }

  }

  isCollaudo(){
    return environment.APIendpoint == 'https://talabservicescollaudo.it:8443' ? true : false;
  }

  isProd(){
    return environment.APIendpoint == 'https://unisaprod.it:8443' ? true : false;
  }

  isPreprod(){
    return environment.APIendpoint == 'https://applicativiunisapreprod.it:8443' ? true : false;
  }

  cambiaRuolo(ruolo) {

    var authUser = JSON.parse(sessionStorage.getItem("authUser"));
    authUser.actionRole = ruolo;

    if(authUser.fotoUrl == null || authUser.fotoUrl == "") {

      if(authUser.actionRole==1) {
      
        authUser.fotoUrl = "assets/images/docente.png";
  
      } else if(authUser.actionRole==2 || authUser.actionRole==5) {
        
        authUser.fotoUrl = "assets/images/docente.png";
  
      } else if(authUser.actionRole==3) {
        
        authUser.fotoUrl = "assets/images/updc.png";
  
      } else if(authUser.actionRole==4 || authUser.actionRole==6) {
        
        authUser.fotoUrl = "assets/images/rettore.png";
  
      }

    }

    sessionStorage.setItem("authUser",JSON.stringify(authUser));

    if(authUser.actionRole==1) {
      
      window.location.href = "/pages/autorizzazioni-e-comunicazioni/dashboard-docente";

    } else if(authUser.actionRole==2 || authUser.actionRole==5) {
      
      window.location.href = "/pages/autorizzazioni-e-comunicazioni/dashboard-direzione";

    } else if(authUser.actionRole==3) {
      
      window.location.href = "/pages/autorizzazioni-e-comunicazioni/dashboard-updc";

    } else if(authUser.actionRole==4 || authUser.actionRole==6) {
      
      window.location.href = "/pages/autorizzazioni-e-comunicazioni/dashboard-rettore";

    }

  }

  addRemoveNotificaForRemove(notifica){
    let ref = this;

    if(!ref.listaNotificheToRemove.includes(notifica.idNotificheProgetti)){
      ref.listaNotificheToRemove.push(notifica.idNotificheProgetti);
    } else {
      if(ref.listaNotificheToRemove.length==1){
        ref.listaNotificheToRemove = [];
      } else {
        
        let index = ref.listaNotificheToRemove.findIndex(n => n == notifica.idNotificheProgetti);
        
        ref.listaNotificheToRemove.splice(index, 1);
      }
    }

    console.log("notifica >>", notifica.idNotificheProgetti);
    console.log("ref.listaNotificheToRemove >>", ref.listaNotificheToRemove);
    
  }

  removeNotifica(event: Event, notifica: any) {
    // Questo eviterà che l'evento si propaghi ai genitori
    event.stopPropagation();

    // Qui puoi gestire la rimozione della notifica
    // Esempio: chiamata a una funzione per rimuovere la notifica dalla lista
    this.addRemoveNotificaForRemove(notifica);
  }

  deleteListNotificheProgettiById(){
    let ref = this;

    let request = {
      "notificheProgettiBindList": []
    }

    ref.listaNotificheToRemove.forEach(not=>{
      request.notificheProgettiBindList.push(
        {
          "idNotificheProgetti": not
        }
      )
    })

    ref.confirmModalComponent.confirm('CONFERMA OPERAZIONE', 'Sicuro di voler eliminare le notifiche selezionate?');
    ref.confirmModalComponent.onClose().subscribe(
      ((res: boolean) => {
          if(res != null && res == true) {
            ref.restService.deleteListNotificheProgettiById(request).then(
              res2=>{
                if(res2!=null && res2.errorCode==0){
                  ref.listaNotificheToRemove = [];
                  ref.modalComponent.openModal("CONFERMA OPERAZIONE", "Notifiche eliminate con successo.");
                  ref.getAllNotifiche();
                }
              }
            )
          }
      })
    );
    
  }

  deleteNotificheProgettiByExtUserIdDestinatario(){
    let ref = this;

    ref.confirmModalComponent.confirm('CONFERMA OPERAZIONE', 'Sicuro di voler eliminare tutte le notifiche?');
    ref.confirmModalComponent.onClose().subscribe(
      ((res: boolean) => {
          if(res != null && res == true) {
            ref.restService.deleteNotificheProgettiByExtUserIdDestinatario().then(
              res2=>{
                if(res2!=null && res2.errorCode==0){
                  ref.listaNotificheToRemove = [];
                  ref.modalComponent.openModal("CONFERMA OPERAZIONE", "Notifiche eliminate con successo.");
                  ref.getAllNotifiche();
                }
              }
            )
          }
      })
    );
    
  }

  getNameApp() {
    let ref = this;

    let nameUrlComponent = this.router.url.split("/")[2];
    nameUrlComponent = nameUrlComponent.split('/')[0];
    console.log('nameUrlComponent >>', nameUrlComponent);
    
    ref.appInUso = { titolo: "" };

    if (nameUrlComponent == 'gestione-utenti') {
      ref.appInUso.titolo = "ANAGRAFICHE";
    } else if (nameUrlComponent == 'gestione-controllo-budget') {
      ref.appInUso.titolo = "GESTIONE CONTROLLO BUDGET";
    } else if (nameUrlComponent == 'progetti-unisa') {
      ref.appInUso.titolo = "PROGETTI";
    } else if (nameUrlComponent == 'allocazione') {
      ref.appInUso.titolo = "ALLOCAZIONE STIPENDI";
    } else if (nameUrlComponent == 'allocazione-tasse') {
      ref.appInUso.titolo = "ALLOCAZIONE TASSE";
    } else if (nameUrlComponent == 'decreti-liquidazione') {
      ref.appInUso.titolo = "DECRETI DI LIQUIDAZIONE";
    } else if (nameUrlComponent == 'strutture') {
      ref.appInUso.titolo = "STRUTTURE";
    } else if (nameUrlComponent == 'gestione-compensi') {
      ref.appInUso.titolo = "GESTIONE COMPENSI";
    }

  }

  getAllNotifiche(){
    this.restService.getAllNotifiche().then(
      res =>{
        this.notificheList = res.notificheProgettiBindList;
        this.getCountNewNotifcations();
        if(this.notificheList && this.notificheList.length>0){
          this.notificheList.forEach(notifica => {
            notifica.visible = true;
            notifica.data = new Date(notifica.data).toLocaleString();
          });
        }
      }
    )
  }

  getCountNewNotifcations(){
    this.countNotifiche = 0;
    if(this.notificheList && this.notificheList.length>0){
      this.notificheList.forEach(notifica => {
        if(notifica.stato==1){
          this.countNotifiche++;
        }
      });
    }

  }

  dettaglioNotifica(el){
    let ref = this;

    let request = {
      notificheProgettiBind: {
        idNotificheProgetti: el.idNotificheProgetti,
        stato: 2
      }
    }

    if(el.stato==1){
      el.stato=2;
      this.getCountNewNotifcations();
      ref.restService.cambiaStatoNotificheProgetti(request).then(()=>{})
    }
    
    this.confirmModalComponent.confirm(el.oggetto, `${el.corpoDelMessaggio}</br> Si desidera andare al dettaglio del Progetto in questione con ID: ${el.extEntityId}?`);
    this.confirmModalComponent.onClose().subscribe(
      ((res: boolean) => {
          if(res != null && res == true) {

            this.routeTo('/pages/progetti-unisa/progetti/view/'+el.extEntityId);
            
          }
      })
    );
    
  }

  openNotifiche(el){
    this.viewNotifiche = !this.viewNotifiche;
    el.scrollTop = 0;
  }

  filterNotification(filter){
    if(this.notificheList && this.notificheList.length > 0){
      this.notificheList.forEach(notifica =>{
        if(notifica.corpoDelMessaggio.toLowerCase().includes(filter.toLowerCase())){
          notifica.visible = true;
        } else {
          notifica.visible = false;
        }
      })
    }
  }

  routeTo(path: any) {
    this.router.navigate([path]);
  }

}